import * as localStorage from '@drc-eca/eca-lrc-common-ui';

export interface IScannerSource {
  index: number;
  name: string;
  ImageCaptureDriverType?: number;
  driverTypeName?: string;
}

export class DefaultScannerService {
  readonly defaultScanner = DefaultScannerService.getLocalStorageItem('localScanning:defaultScanner');

  static getLocalStorageItem(key: string): string {
    return localStorage.getLocalStorageItem(key);
  }

  getDefaultScanner(): IScannerSource {
    if (this.defaultScanner) {
      const [index, name, driverType] = this.defaultScanner.split(':');

      const source: IScannerSource = {
        index: Number(index),
        name,
      };

      if (driverType) {
        source.ImageCaptureDriverType = Number(driverType);
      }

      return source;
    }
    return null;
  }
}
